export enum PlayState {
  STARTING_TO_PLAY = "StartingToPlay",
  PLAYING = "Playing",
  PAUSED = "Paused",
  STOPPED = "Stopped",
}
